module.exports = __webpack_public_path__ + "static/media/arrow-upper.0746450c.svg";